import { useCallback as o } from "react";
import { useConfirmContext as r } from "../providers/ConfirmDialogProvider/hooks/useConfirmContext.js";
const t = ({ dirty: t2, resetForm: e, onClose: i }) => {
  const { confirm: n } = r();
  return o(() => {
    const o2 = () => {
      e(), i == null ? void 0 : i();
    };
    t2 ? n(o2) : o2();
  }, [n, t2, i, e]);
};
export {
  t as useConfirmFormCancel
};
//# sourceMappingURL=useConfirmFormCancel.js.map
